import { render, staticRenderFns } from "./WorkspaceMemberSettingsTable.vue?vue&type=template&id=0ce4672a&scoped=true"
import script from "./WorkspaceMemberSettingsTable.vue?vue&type=script&lang=js"
export * from "./WorkspaceMemberSettingsTable.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceMemberSettingsTable.vue?vue&type=style&index=0&id=0ce4672a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce4672a",
  null
  
)

export default component.exports